export const DRUGS = 'DRUGS'
export const PROFANITY = 'PROFANITY'
export const SEX = 'SEX'
export const VIOLENCE = 'VIOLENCE'
